import React from "react";

import WatchingFeature from "../features/watching";

function Watching(props) {
  return <WatchingFeature {...props} />;
}

export default Watching;
